import React, { useState } from "react";
import {
  Paper,
  Box,
  Button,
  Typography,
  Chip,
  CircularProgress,
  Divider,
} from "@material-ui/core";
import AsignacionesV2Service from "../services/asignacionesV2";

interface Props {
  psId: string | number;
}

const pct = (v: any) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

// Banda de color segun la propension al cambio (igual criterio que EMSYS).
const banda = (p: number) => {
  if (p < 30) return { color: "#2e7d32", label: "Estable" };
  if (p < 60) return { color: "#ed6c02", label: "Seguimiento" };
  return { color: "#c62828", label: "Prioritario" };
};

// Panel de analisis de los operarios ya asignados (propension al cambio + IA).
const AnalisisAsignados: React.FC<Props> = ({ psId }) => {
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [cargado, setCargado] = useState(false);
  const [webhookAplicado, setWebhookAplicado] = useState(false);

  const analizar = async () => {
    if (!psId) return;
    setLoading(true);
    const res = await AsignacionesV2Service.analisisAsignados(psId, 0);
    setItems(res.datos || []);
    setWebhookAplicado(res.webhookAplicado);
    setCargado(true);
    setLoading(false);
  };

  return (
    <Paper style={{ width: "100%", padding: 8 }}>
      <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap">
        <Typography variant="subtitle1" style={{ fontWeight: "bold", color: "#910434" }}>
          Análisis de operarios asignados
        </Typography>
        <Button
          variant="contained"
          disabled={loading}
          onClick={analizar}
          style={{ background: "#910434", color: "white" }}
        >
          {loading ? "ANALIZANDO..." : cargado ? "ACTUALIZAR" : "ANALIZAR ASIGNADOS"}
        </Button>
      </Box>

      {/* Leyenda de bandas */}
      {cargado && items.length > 0 && (
        <Box display="flex" style={{ gap: 8, margin: "8px 0" }} flexWrap="wrap">
          <Chip size="small" label="Estable (<30%)" style={{ background: "#2e7d32", color: "white" }} />
          <Chip size="small" label="Seguimiento (30-60%)" style={{ background: "#ed6c02", color: "white" }} />
          <Chip size="small" label="Prioritario (≥60%)" style={{ background: "#c62828", color: "white" }} />
          {!webhookAplicado && (
            <Typography variant="caption" style={{ color: "#777", alignSelf: "center" }}>
              (sin IA: justificación por reglas)
            </Typography>
          )}
        </Box>
      )}

      {loading && (
        <Box display="flex" justifyContent="center" py={2}>
          <CircularProgress size={28} />
        </Box>
      )}

      {cargado && !loading && items.length === 0 && (
        <Typography variant="body2" style={{ padding: 8 }}>
          No hay datos de análisis para los operarios asignados.
        </Typography>
      )}

      {items.map((it, idx) => {
        const p = pct(it.propension_cambio);
        const b = banda(p);
        const nombre = it.nombres || it.operario || "";
        const legajo = it.nroLegajo || it.legajo || "";
        const metricas = [
          it.promedio_evaluacion != null ? `Eval: ${Number(it.promedio_evaluacion).toFixed(0)}` : null,
          it.tardanzas != null ? `Tardanzas: ${it.tardanzas}` : null,
          it.ausencias != null ? `Ausencias: ${it.ausencias}` : null,
          it.cantidad_reclamos != null ? `Reclamos: ${it.cantidad_reclamos}` : null,
        ]
          .filter(Boolean)
          .join("  •  ");
        return (
          <Box key={`${legajo}-${idx}`} style={{ borderLeft: `4px solid ${b.color}`, padding: "6px 10px", margin: "6px 0", background: "#fafafa" }}>
            <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap">
              <Typography variant="body2" style={{ fontWeight: "bold" }}>
                {nombre} {legajo ? `- ${legajo}` : ""}
              </Typography>
              <Chip size="small" label={`${b.label} · ${p.toFixed(0)}%`} style={{ background: b.color, color: "white" }} />
            </Box>
            {it.justificacion_ia && (
              <Typography variant="caption" style={{ display: "block", marginTop: 4 }}>
                {it.justificacion_ia}
              </Typography>
            )}
            {metricas && (
              <>
                <Divider style={{ margin: "4px 0" }} />
                <Typography variant="caption" style={{ color: "#555" }}>
                  {metricas}
                </Typography>
              </>
            )}
          </Box>
        );
      })}
    </Paper>
  );
};

export default AnalisisAsignados;
